import { render, staticRenderFns } from "./DatepickerHeader.vue?vue&type=template&id=51d876ec&scoped=true&lang=pug&"
import script from "./DatepickerHeader.vue?vue&type=script&lang=js&"
export * from "./DatepickerHeader.vue?vue&type=script&lang=js&"
import style0 from "./DatepickerHeader.vue?vue&type=style&index=0&id=51d876ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d876ec",
  null
  
)

export default component.exports